export default __webpack_public_path__ + "static/media/zymran-bg.8afe3ff3.png";